module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedicationPage"
  }, [_c('a', {
    attrs: {
      "id": "title11"
    }
  }, [_c('p', {
    staticClass: "p-c"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("DEDICATIONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-c"
  }, [_c('span', [_c('br'), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("This book is dedicated to boxing historians Dr. Nick Beck, of Los Angeles, California, the late Bob Soderman of Chicago, Illinois, and the late Bob Shepard of New York City.")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-d"
  }, [_c('span', [_vm._v("–J.J. Johnston")])]), _vm._v(" "), _c('p', {
    staticClass: "p-c"
  }, [_c('span', [_c('br'), _c('br'), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("To Chuck Bodak, my boxing mentor, and to my Army coach Sgt. Earl K. Hussey.")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-d"
  }, [_c('span', [_vm._v("–Sean Curtin")])])])]), _c('a', {
    attrs: {
      "id": "title11"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d227f90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781439614785_ded01.vue
// module id = 72
// module chunks = 0